export default __webpack_public_path__ + "static/BFcWMhVB-69a697a43419818710382d91571662b6.svg";